module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_1.eb0c81de.png";